import {
  ComponentDescriptorOrArray,
  getRendererFromDescriptor,
  useField,
  usePage,
  useWizardService,
} from '@kizi/comparator-core';
import React, { useEffect, useState } from 'react';
import { PageLayout, PageLayoutProps } from '../../PageLayout';
import { sendCustomEvent } from '../TabViewWizard/ApplyPageWizard';
import { AffiliateUrlModal } from '../../AffiliateUrlModal';

export interface ComparisonPageProps extends PageLayoutProps {
  comparisonProducts: string;
  extraProductsDataFn?: (products, setProducts) => void;
  noComparisonNavigationIndex?: number;
  affiliateUrlClientId?: string;
  affiliatePageDescriptor?: ComponentDescriptorOrArray;
}

export const ComparisonPage: React.FC<ComparisonPageProps> = ({
  comparisonProducts,
  extraProductsDataFn,
  noComparisonNavigationIndex = 2,
  affiliateUrlClientId,
  affiliatePageDescriptor,
  ...pageLayoutProps
}) => {
  const { state, setState } = usePage();
  const field = useField(comparisonProducts);

  const service = useWizardService();
  if (!field || !field.hasOwnProperty('value') || !service) return null;

  const [products, setProducts] = useState(
    field?.value ? JSON.parse(field.value as string) : undefined
  );

  useEffect(() => {
    if (extraProductsDataFn) {
      extraProductsDataFn(products, setProducts);
    }
    sendCustomEvent('comparison-page', {});
  }, []);

  useEffect(() => {
    if (field.value === undefined) {
      service.send([{ type: 'GOTO', index: noComparisonNavigationIndex }]);
    } else {
      setState?.({
        ...state,
        comparisonProducts: products,
      });
    }

    return () => field.set({ value: undefined });
  }, [products]);

  const isAffiliateUrl = location.href.includes('affiliateUrl');

  const handleAffiliateUrlModal = ({
    affiliatePageDescriptor,
    affiliateUrlClientId,
  }) => {
    return affiliatePageDescriptor ? (
      <>
        {getRendererFromDescriptor({
          ...affiliatePageDescriptor,
          props: {
            ...affiliatePageDescriptor.props,
            affiliateUrlClientId,
          },
        })}
      </>
    ) : (
      <AffiliateUrlModal affiliateUrlClientId={affiliateUrlClientId} />
    );
  };
  return (
    <>
      {isAffiliateUrl ? (
        handleAffiliateUrlModal({
          affiliatePageDescriptor,
          affiliateUrlClientId,
        })
      ) : (
        <PageLayout {...pageLayoutProps} />
      )}
    </>
  );
};
